import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56aae4db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choice-history-container" }
const _hoisted_2 = { class: "choice-history-banner" }
const _hoisted_3 = { class: "choice-history-banner-content" }
const _hoisted_4 = { class: "banner-title" }
const _hoisted_5 = { class: "banner-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/history_img.png",
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "choice-history" }
const _hoisted_8 = { class: "choice-history-content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "item-time" }
const _hoisted_11 = { class: "month" }
const _hoisted_12 = { class: "year" }
const _hoisted_13 = { class: "line" }
const _hoisted_14 = {
  key: 0,
  class: "item-line"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-point" }, null, -1))
const _hoisted_16 = { class: "product-info" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "product-main" }
const _hoisted_19 = { class: "product-item-text line--2" }
const _hoisted_20 = { class: "product-num" }

import { t } from '@/plugins/i18n'
import { queryCustomerShareLinksApi } from '@/apis/goods'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import Image from '@/components/common/Image.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const list: any = ref([])
onMounted(async () => {
  const { data } = await queryCustomerShareLinksApi({
    customerId: store.getters.user.customerId,
    pageNo: 1,
    pageSize: 1000
  })
  list.value = data?.records ?? []
})
const jump = (item: { shareCode: string }) => {
  router.push(useRtfix('ckbChoice', { params: { code: item.shareCode } }))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('一对一专属选品提案')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('CKB对于高级会员一对一定制化选品提案。将喜欢的商品加入心愿清单，CKB会为您快速创建商品。')), 1),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "choice-history-item",
            key: index,
            onClick: ($event: any) => (jump(item))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(item.createTime?.slice(5, 10)), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.createTime?.slice(0, 4)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (index !== list.value.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                : _createCommentVNode("", true),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(Image, {
                  src: item.headerImage,
                  alt: "",
                  fit: "cover",
                  class: "img"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, " 「THE 直行便」" + _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('本次推荐包含：X件商品').replace('X', item.atlasCodes?.length)), 1)
                ])
              ])
            ])
          ], 8, _hoisted_9))
        }), 128))
      ])
    ])
  ]))
}
}

})